import React from 'react';
import {injectIntl, FormattedMessage} from 'react-intl';
import { i18nIntl} from '../../lib/ep.js';

import { sweep as const_sweep } from './bootstrap';

import ActionLink from '../builder/ActionLink';
import FloatingLayer from '../builder/FloatingLayer';
import SectionSubtitle from '../builder/SectionSubtitle';
import SectionTitle from '../builder/SectionTitle';

import SinglePromoInsight from '../insights/SinglePromoInsight.js';

const SweepElasticStats = ({sweep,subspro, ...props}) => {
    const i18n = (m, c) => i18nIntl(m, props.intl, c);
    const _event_stats = {
        action:'link',
        category:'admin',
        platform:'panel',
        value:'buy_subs_basicpro_' + sweep.network + '_stats',
    };

    const closeLayer = () => {
		if(props.close != undefined) props.close();
	};


    if(!subspro) {
        return (
            <FloatingLayer backButton={()=>closeLayer()} _class={{size:'small'}}>
                <div class="without_actions">
                    <SectionTitle _class={{in_top:true,icon:true,other:"with_pro_mark is_big"}} autotranslate={false}><span class="is_pro_mark">PRO</span>{i18n("PRO feature")}</SectionTitle>
                    <SectionSubtitle autotranslate={false}>
                        <FormattedMessage id="To see advanced statistics about your giveaway, you need an {label}" values={{label:<ActionLink _gaEvent={_event_stats} _href={window.panel_url+const_sweep.subscription_link_pro+'?stats'} autotranslate={false}>{i18n("active Basic PRO plan")}</ActionLink>}}/>.
                    </SectionSubtitle>
                    <SectionSubtitle autotranslate={false}>
                        {i18n("Advanced statistics include graphs and charts about how participation evolves each day, peak participation times, unique users, and more.")+' '}
                        <ActionLink _href={window.zendesk_base_url+'360018240231'} _target="_blank">Click here to learn about PRO statistics.</ActionLink>
                    </SectionSubtitle>
                </div>
            </FloatingLayer>
        )
    }

    return (
        <FloatingLayer _class={{size:'fullscreen' }}  backButton={()=>closeLayer()}>
            <div class="without_actions">
                <SinglePromoInsight
                    type={'sweep'}
                    sweep={sweep}
                    active={{
                        key:'sweep',
                        icon:'knk-stats',
                        title:"Participants",
                    }}
                    intl={props.intl}
                />
            </div>
        </FloatingLayer>
    )
}

export default injectIntl(SweepElasticStats);